var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
import cn from 'classnames';
import Toggle from '../toggle';
import ToggleContext from '../toggleContext';
var FaqContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-auto-rows: auto;\n  grid-row-gap: 10px;\n  background-color: #f7f6f6;\n  box-sizing: border-box;\n  width: 100%;\n  object-fit: fill;\n  padding-top: 20px;\n  padding-bottom: 20px;\n"])));
FaqContainer.displayName = 'FaqContainer';
var ToggledFaqAnswer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #42484d;\n  padding-bottom: 20px;\n  padding-right: 26px;\n  margin-top: 0;\n  margin-bottom: 0;\n  width: 100%;\n"])));
ToggledFaqAnswer.displayName = 'ToggledFaqAnswer';

var FaqQuestion = function FaqQuestion(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      restProps = _objectWithoutProperties(_ref, ["children", "className", "dataAnalyticsLabel"]);

  var flattenChildren = React.Children.toArray(children);
  var question = flattenChildren[0];
  var answer = flattenChildren[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var toggle = function toggle() {
    setExpanded(!isExpanded);
  };

  var toggleState = {
    isExpanded: isExpanded,
    toggle: toggle
  };
  return /*#__PURE__*/React.createElement(ToggleContext.Provider, {
    value: toggleState
  }, /*#__PURE__*/React.createElement(Toggle, _extends({
    key: question,
    className: cn(className, 'faq-visible-content'),
    text: question,
    dataAnalyticsLabel: dataAnalyticsLabel
  }, restProps), /*#__PURE__*/React.createElement(ToggledFaqAnswer, {
    className: "faq-collapsed-content",
    key: question
  }, answer)));
};

FaqQuestion.propTypes = {
  /**
   Required and consists of everything between opening and closing tags when invoking component
  */
  children: node.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Optional label for analytics tracking
  */
  dataAnalyticsLabel: string
};
export default FaqQuestion;